export default __webpack_public_path__ + "cef73a82c897bbb7367654fdf92ec848.jpg";